export const getPracticeUrl = (
  enabled: boolean,
  pathname: string,
  languagePairId?: number | null,
  page?: string,
) => {
  return enabled
    ? {
        pathname,
        query: {
          language_pair_id: languagePairId,
          back: page,
        },
      }
    : '';
};
